import script from "./PotasiumDrag.vue?vue&type=script&setup=true&lang=js"
export * from "./PotasiumDrag.vue?vue&type=script&setup=true&lang=js"

import "./PotasiumDrag.vue?vue&type=style&index=0&id=5e190f40&lang=css"

const __exports__ = script;

export default __exports__